import {Card} from '@shopify/polaris';
import * as React from 'react';

import styles from './Table.scss';

export interface Props {
  title?: React.ReactNode;
  subtitle?: string;
  headerRows?: React.ReactNode[];
  children: React.ReactNode;
}

export function Table({title, subtitle, headerRows, children}: Props) {
  const titleMarkup =
    title || subtitle ? (
      <tr className={styles.Title__Row}>
        <th
          colSpan={3}
          style={{
            gridColumn: '1 / -1',
          }}
          className={styles.Title__Cell}
        >
          {title}
          {subtitle ? (
            <p className={styles.Title__Cell__Subtitle}>{subtitle}</p>
          ) : null}
        </th>
      </tr>
    ) : null;

  const headerMarkup =
    headerRows && headerRows.length === 3 ? (
      <tr className={styles.Header__Row}>
        <th className={styles.Header__Cell}>{headerRows[0]}</th>
        <th className={styles.Header__Cell} scope="col">
          {headerRows[1]}
        </th>
        <th className={styles.Header__Cell} scope="col">
          {headerRows[2]}
        </th>
      </tr>
    ) : null;

  return (
    <Card background="bg-surface" padding="0">
      <table className={styles.Table}>
        <thead className={styles.Table__Head}>
          {titleMarkup}
          {headerMarkup}
        </thead>
        <tbody className={styles.Table__Body}>{children}</tbody>
      </table>
    </Card>
  );
}
